import { check } from './check';
import { integration } from './integration';
import { integral } from './integral';
import { maxY } from './maxY';
import { maxYPoint } from './maxYPoint';
import { minYPoint } from './minYPoint';
import { reduce } from './reduce';
import { sortX } from './sortX';
import { minClosestYPoint } from './minClosestYPoint';
import { maxClosestYPoint } from './maxClosestYPoint';
import { realMinYPoint } from './realMinYPoint';
import { realMaxYPoint } from './realMaxYPoint';

export const XY = {
  check,
  integral,
  integration,
  maxY,
  maxYPoint,
  minYPoint,
  reduce,
  sortX,
  minClosestYPoint,
  maxClosestYPoint,
  realMaxYPoint,
  realMinYPoint,
};
